export default function SubscribeCTA() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            不想错过任何一个瓜？
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            订阅我们的每日推送，第一时间获取最新网红爆料、明星黑料和热门追踪资讯。吃瓜快人一步！
          </p>

          <form
            data-readdy-form="home-subscribe"
            className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3 max-w-md mx-auto"
            onSubmit={(e) => e.preventDefault()}
          >
            <input
              type="email"
              name="email"
              placeholder="输入你的邮箱地址"
              className="w-full sm:flex-1 px-5 py-3 rounded-full border border-foreground-300 bg-background-50 text-sm text-foreground-900 placeholder-foreground-400 outline-none focus:border-primary-500 focus:ring-2 focus:ring-primary-100 transition-all"
            />
            <input
              type="text"
              name="phone_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="honeypot-field"
            />
            <button
              type="submit"
              className="whitespace-nowrap w-full sm:w-auto px-8 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors duration-200 cursor-pointer inline-flex items-center justify-center gap-2"
            >
              立即订阅
              <i className="ri-arrow-right-line"></i>
            </button>
          </form>

          <p className="mt-4 text-xs text-foreground-500">
            已有 <strong className="text-primary-600">320万</strong> 吃瓜群众加入，每日更新不迷路
          </p>
        </div>

        <div className="mt-12 relative rounded-2xl overflow-hidden h-[200px] md:h-[280px] max-w-4xl mx-auto">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20abstract%20banner%20with%20flowing%20gradients%20in%20crimson%20amber%20and%20soft%20gold%20tones%2C%20modern%20minimal%20digital%20art%20style%2C%20smooth%20organic%20shapes%2C%20clean%20sophisticated%20aesthetic%2C%20no%20text%2C%20editorial%20background%2C%20high%20quality%20abstract%20composition&width=1200&height=400&seq=cta-banner-91&orientation=landscape"
            alt="订阅91在线吃瓜每日推送"
            title="91在线吃瓜 订阅推送"
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>
    </section>
  );
}